import type { LegalDoc } from '../../types/legal'

/** PLACEHOLDER — drafting notes only. Replace with reviewed legal text before publishing. */
export const privacyPolicy: LegalDoc = {
  slug: 'privacy',
  title: 'Privacy policy',
  lastUpdated: '[date]',
  version: '[x.x]',
  summary: [
    'We collect the information needed to run your Kayko account, process payments, and keep your business records.',
    'We do not sell your personal information.',
    'We share information with partners such as lenders only when needed to provide a service, or when you ask us to.',
    'You can ask to see, correct, export, or delete your information at any time.',
  ],
  sections: [
    {
      id: 'who-we-are',
      title: 'Who we are',
      blocks: [
        {
          type: 'paragraph',
          text: '[Placeholder] Identify Kayko Group Ltd as the data controller, with registered address, company number, and BNR licence reference as an Electronic Money Institution and Payment Service Provider.',
        },
        {
          type: 'definitions',
          items: [
            { term: '“Kayko”, “we”, “us”', description: '[Placeholder] Define the legal entity this policy covers.' },
            { term: '“You”', description: '[Placeholder] Define account holders, their staff users, and their customers.' },
            { term: '“Personal information”', description: '[Placeholder] Define by reference to Rwanda’s data protection law.' },
          ],
        },
      ],
    },
    {
      id: 'information-we-collect',
      title: 'Information we collect',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] Introduce the categories of information collected and their sources.' },
      ],
      subsections: [
        {
          title: 'Information you give us',
          blocks: [
            {
              type: 'list',
              items: [
                '[Placeholder] Account details: name, phone number, email, business name.',
                '[Placeholder] Identity and verification documents required for e-money accounts.',
                '[Placeholder] Business records you enter: sales, stock, expenses, customers.',
              ],
            },
          ],
        },
        {
          title: 'Information we collect automatically',
          blocks: [
            {
              type: 'list',
              items: [
                '[Placeholder] Device and log information.',
                '[Placeholder] Transaction and payment data.',
                '[Placeholder] Cookies and similar technologies — see section 10.',
              ],
            },
          ],
        },
        {
          title: 'Information from third parties',
          blocks: [
            { type: 'paragraph', text: '[Placeholder] Describe data received from payment providers, lending partners, and verification services.' },
          ],
        },
      ],
    },
    {
      id: 'how-we-use',
      title: 'How we use your information',
      blocks: [
        {
          type: 'list',
          items: [
            '[Placeholder] To provide and maintain the Kayko service.',
            '[Placeholder] To process payments and hold e-money balances.',
            '[Placeholder] To meet anti-money-laundering and regulatory obligations.',
            '[Placeholder] To assess eligibility for Business Financing when you apply.',
            '[Placeholder] To send service messages and, with consent, product updates.',
          ],
        },
      ],
    },
    {
      id: 'legal-basis',
      title: 'Legal basis',
      blocks: [
        {
          type: 'table',
          caption: 'Legal basis for each purpose (placeholder)',
          columns: ['Purpose', 'Legal basis'],
          rows: [
            ['[Providing the service]', '[Contract — to confirm]'],
            ['[Regulatory checks]', '[Legal obligation — to confirm]'],
            ['[Business Financing assessment]', '[Consent — to confirm]'],
            ['[Product updates]', '[Consent — to confirm]'],
          ],
        },
      ],
    },
    {
      id: 'sharing',
      title: 'Sharing your information',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] List categories of recipients and why information is shared with each.' },
        {
          type: 'list',
          items: [
            '[Placeholder] Payment and banking partners.',
            '[Placeholder] Mula Financial Services Ltd, when you apply for Business Financing.',
            '[Placeholder] Service providers acting on our instructions.',
            '[Placeholder] Regulators and authorities where required by law.',
          ],
        },
      ],
    },
    {
      id: 'international-transfers',
      title: 'International transfers',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] State where data is stored and the safeguards used for any transfer outside Rwanda.' },
      ],
    },
    {
      id: 'retention',
      title: 'How long we keep data',
      blocks: [
        {
          type: 'table',
          caption: 'Retention periods (placeholder)',
          columns: ['Type of data', 'Retention period'],
          rows: [
            ['[Account information]', '[to confirm]'],
            ['[Transaction records]', '[to confirm]'],
            ['[Verification documents]', '[to confirm]'],
          ],
        },
      ],
    },
    {
      id: 'security',
      title: 'Security',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] Summarise technical and organisational measures. Link to the Security & compliance page.' },
      ],
    },
    {
      id: 'your-rights',
      title: 'Your rights',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] List the rights available under Rwanda’s data protection law and how to exercise them.' },
        {
          type: 'list',
          items: [
            '[Placeholder] Right to access your information.',
            '[Placeholder] Right to correct inaccurate information.',
            '[Placeholder] Right to deletion, subject to legal retention duties.',
            '[Placeholder] Right to object or withdraw consent.',
            '[Placeholder] Right to data portability.',
          ],
        },
        {
          type: 'callout',
          title: 'Request a copy of your data',
          text: '[Placeholder] Explain how to submit a request, what identification is needed, and the response time [to confirm].',
          action: { label: 'Request your data', href: '/contact' },
        },
      ],
    },
    {
      id: 'cookies',
      title: 'Cookies',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] Summarise cookie use and refer to the Cookie policy for details and choices.' },
      ],
    },
    {
      id: 'changes',
      title: 'Changes to this policy',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] Explain how and when users will be notified of material changes.' },
      ],
    },
    {
      id: 'contact',
      title: 'Contact us',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] Provide Data Protection Officer contact details and the right to complain to the supervisory authority.' },
      ],
    },
  ],
}
